import "core-js/modules/es.array.sort.js";
import React from 'react';
import styled from 'styled-components';
import { pxToRem } from 'utils/ui';
import { borderValue } from 'styles/mixins';
import Text from 'components/Text';
import { tableCellBaseStyles, tableCellPropFilter } from '../TableCell';
import { withTableContext } from '../TableContext';
import ClickableHeader from './ClickableHeader';
import { getColumnName, headerBackgroundColor, getCheckboxColumnWidth } from '../../utils';
var ARIA_SORT_LABEL = {
  asc: 'ascending',
  desc: 'descending'
};
export var Wrapper = withTableContext(styled.th.withConfig({
  shouldForwardProp: tableCellPropFilter
}).withConfig({
  displayName: "TableColumnHeader__Wrapper",
  componentId: "sc-1f1u0qu-0"
})(["", " ", " position:relative;position:sticky;top:", ";z-index:", ";color:", ";&::after{content:'';position:absolute;top:0;bottom:0;left:0;right:0;z-index:", ";border-bottom:", ";", "}"], tableCellBaseStyles, function (p) {
  return p.isCheckbox && "\n\t\twidth: ".concat(getCheckboxColumnWidth(p), ";\n\t");
}, function (p) {
  return pxToRem(p.stickyHeaderOffset || 0);
}, function (p) {
  return p.theme.globals.z.raised;
}, function (p) {
  return p.theme.text;
}, function (p) {
  return p.theme.globals.z.below;
}, function (p) {
  return borderValue(p.theme);
}, headerBackgroundColor));
function TableColumnHeader(_ref) {
  var children = _ref.children,
    column = _ref.column,
    sort = _ref.sort,
    a11yLabels = _ref.a11yLabels,
    onRequestSort = _ref.onRequestSort;
  var hideBelowBreakpoint = column.hideBelowBreakpoint,
    subtitle = column.subtitle,
    width = column.width;
  var columnName = getColumnName(column);
  var isColumnOrderedBy = sort && columnName === sort.column;
  return /*#__PURE__*/React.createElement(Wrapper, {
    scope: "col",
    width: width,
    hideBelowBreakpoint: hideBelowBreakpoint,
    "aria-sort": isColumnOrderedBy ? ARIA_SORT_LABEL[sort.order] : undefined
  }, column.sortable ? /*#__PURE__*/React.createElement(ClickableHeader, {
    isActive: Boolean(isColumnOrderedBy),
    column: column,
    order: sort === null || sort === void 0 ? void 0 : sort.order,
    a11yLabels: a11yLabels,
    onRequestSort: onRequestSort
  }, children) : children, subtitle && /*#__PURE__*/React.createElement(Text, {
    dimmed: true,
    size: "xs",
    display: "block"
  }, subtitle));
}
export default TableColumnHeader;